/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const prodottiAPI = {
  // Cliente: i miei prodotti con stato manutenzioni
  miei: async () => {
    const { data } = await apiClient.get('/prodotti/cliente');
    return data;
  },
  // Dettaglio prodotto (storico + file)
  scadenze: async () => {
    const { data } = await apiClient.get('/prodotti/scadenze/cliente');
    return data;
  },
  detail: async (id) => {
    const { data } = await apiClient.get(`/prodotti/${id}`);
    return data;
  },
};
